export default "__VITE_ASSET__wdv86Tsy__"